export function normalizeHexColor(value) {
    return typeof value === "string" ? value.trim() : "";
}

export function isValidHexColor(value) {
    return /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(
        normalizeHexColor(value),
    );
}

export function getReadableTextClass(colorHex) {
    const normalizedColor = normalizeHexColor(colorHex);
    const red = parseInt(normalizedColor.slice(1, 3), 16);
    const green = parseInt(normalizedColor.slice(3, 5), 16);
    const blue = parseInt(normalizedColor.slice(5, 7), 16);
    const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

    return brightness > 153 ? "text-slate-800" : "text-white";
}

export function getReadableTextColor(colorHex) {
    return getReadableTextClass(colorHex) === "text-slate-800"
        ? "#1e293b"
        : "#ffffff";
}
